export default {
  xs: '0px',
  sm: '600px',
  md: '900px',
  xmd: '950px',
  lg: '1200px',
  xl: '1536px',
}
